import { configureStore } from "@reduxjs/toolkit";
import documentClaimSlice from "./slices/DocumentClaimSlice";

const store = configureStore({
    reducer: {
        documentClaim:documentClaimSlice,
        
    },
});

export default store;